// RatingsLocation Store
import { clone } from 'lodash'
import { getField, updateField } from 'vuex-map-fields'

const rating = {
  id: null,
  title: null,
  overall_evaluation: null,
  softskill_5: null,
  recommendation: null,
  total_count: null,
  last_updated: null,
}

const state = {
  comments: [],
  commentsPagination: {},
  rating: clone(rating),
  ratings: [],
  pagination: {},
  pending: false,
  filterPending: false,
  filterActive: false,
  filterOptions: [],
  filters: {},
  options: {},
}

const getters = {
  getField,
}

const actions = {
  getRatings({ commit }, page = 1) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
        .getItems('ratings', { page, show_locations: true })
        .then(({ data }) => {
          commit('SET_RATINGS', data)
          commit('SET_PENDING')
          resolve()
        })
    })
  },
  getRating({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.getItem(`ratings.${id}`).then(({ data }) => {
        commit('SET_RATING', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getRatingsFilters({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING_FILTERS')
      this.api.items
        .getFilters('ratings', { show_locations: true })
        .then(({ data }) => {
          commit('SET_RATINGS_FILTERS', data)
          commit('SET_PENDING_FILTERS')
          resolve()
        })
    })
  },
  getRatingFilters({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING_FILTERS')
      this.api.items.getItemFilters('ratings', id).then(({ data }) => {
        commit('SET_RATING_FILTERS', data)
        commit('SET_PENDING_FILTERS')
        resolve()
      })
    })
  },
  getRatingComments({ commit }, { id, page }) {
    return new Promise(resolve => {
      commit('SET_PENDING_COMMENTS')
      this.api.ratings.getComments(id, { page }).then(({ data }) => {
        commit('SET_RATING_COMMENTS', data)
        commit('SET_PENDING_COMMENTS')
        resolve()
      })
    })
  },
  filterRatings({ commit, state }, { page }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
        .filterItems('ratings', {
          ...state.filters,
          page,
          show_locations: true,
        })
        .then(({ data }) => {
          commit('SET_RATINGS', data)
          commit('SET_PENDING')
          resolve()
        })
    })
  },
  filterRating({ commit, state }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
        .filterItem(`ratings.${id}`, {
          ...state.filters,
        })
        .then(({ data }) => {
          commit('SET_RATING', data)
          commit('SET_PENDING')
          resolve()
        })
    })
  },
  updateFilters({ commit }, data) {
    commit('UPDATE_FILTERS', data)
  },
  setFilterActive({ commit }) {
    commit('SET_FILTER_ACTIVE')
  },
  resetFilter({ commit }) {
    commit('RESET_FILTER')
  },
  clearRating({ commit }) {
    commit('CLEAR_RATING')
  },
  clearRatings({ commit }) {
    commit('CLEAR_RATINGS')
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_PENDING_FILTERS: state => {
    state.filterPending = !state.filterPending
  },
  SET_PENDING_COMMENTS: state => {
    state.commentsPending = !state.commentsPending
  },
  CLEAR_RATINGS(state) {
    state.filterActive = false
    state.filterOptions = []
    state.filters = {}
    state.pagination = {}
    state.users = []
  },
  CLEAR_RATING(state) {
    state.comments = []
    state.commentsPagination = {}
    state.errors = {}
    state.filterOptions = []
    state.filters = {}
    state.rating = clone(rating)
  },
  SET_FILTER_ACTIVE: state => {
    state.filterActive = true
  },
  RESET_FILTER: state => {
    state.filters = {}
    state.filterActive = false
  },
  SET_RATINGS_FILTERS: (state, data) => {
    state.filterOptions = data
  },
  SET_RATING_COMMENTS: (state, { comments, pagination }) => {
    state.comments = comments
    state.commentsPagination = pagination
  },
  SET_RATING_FILTERS: (state, data) => {
    state.filterOptions = data
  },
  UPDATE_FILTERS: (state, data) => {
    state.filters = data
  },
  SET_RATINGS: (state, data) => {
    state.ratings = data.ratings
    state.pagination = data.pagination
    state.options = data
  },
  SET_RATING: (state, rating) => {
    state.rating = rating
  },
  updateField,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
